var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.toggle}}),_vm._v(" "),_c('span',{staticClass:"slider round",class:{ active: _vm.value }})])}
var staticRenderFns = []

export { render, staticRenderFns }